import React from 'react';
import {useDispatch} from "react-redux";
import {useRouter} from "next/router";

// components
import {Button} from "@material-ui/core";

// actions
import { toggleDrawer } from '~/slices/commons/drawer'
import { setSearchType, setSearchPreset } from '~/slices/items/itemSearchOption'

// resources
import { presetItemFeature } from '~/data/shop/itemSearchPreset'

export const ItemFeature = (props) => {
  const { searchType } = props
  const dispatch = useDispatch()
  const router = useRouter()

  const searchPreset = (value) => {
    dispatch(setSearchType(searchType))
    dispatch(setSearchPreset(value))
    dispatch(toggleDrawer({openFlg: false, key: 'search'}))

    const pathname = '/items/'
    router.push(pathname)
  }

  return (
      <div>
        <ul>
          {
            presetItemFeature.list.map((item, index) => (
                <li key={index}>
                  <Button onClick={() => searchPreset({itemFeature: item.code})}>
                    {
                      item.label
                    }
                  </Button>
                </li>
            ))
          }
        </ul>
      </div>
  );
};
